import { useQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { GetCurrentUserResponse } from 'compliance-api';

export const COMPLIANCE_CURRENT_USER_QUERY_KEY = 'vestra-compliance/current-user';
export const COMPLIANCE_USER_SIGN_UP_NOW_QUERY_KEY = 'vestra-compliance/user-sign-up-now';

export const useCurrentUserQuery = (disabled = false) => {
  return useQuery<GetCurrentUserResponse>({
    queryKey: [COMPLIANCE_CURRENT_USER_QUERY_KEY],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    queryFn: async () => {
      const response = await api.v1.getCurrentUserV1UsersCurrentGet();
      return response.data;
    },
    enabled: !disabled,
  });
};
